// src/queries/roleApiConfig.js

import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * ROLE API CONFIGURATION
 * Integrated with pms-api REST endpoints: /api/v1/roles
 */
export const roleConfig = {
  /* -------------------------------- GET --------------------------------- */
  getAllRoles: {
    key: "getAllRoles",
    url: "/api/v1/roles",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getPmsAdminRoleForCreate: {
    key: "getPmsAdminRoleForCreate",
    url: "/api/v1/roles",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getPmsAdminAccessibleRoles: {
    key: "getPmsAdminAccessibleRoles",
    url: "/api/v1/roles",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getRolesByCurrentUser: {
    key: "getRolesByCurrentUser",
    url: "/api/v1/roles",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getDeletedRoles: {
    key: "getDeletedRoles",
    url: "/api/v1/roles/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getRoleById: {
    key: "getRoleById",
    url: (id) => `/api/v1/roles/${id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- POST -------------------------------- */
  createRole: {
    key: "createRole",
    url: "/api/v1/roles",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllRoles", "getDeletedRoles"],
    },
  },

  restoreRole: {
    key: "restoreRole",
    url: (data) => `/api/v1/roles/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getAllRoles", "getDeletedRoles"],
    },
  },

  // TODO: pending pms-api implementation (hard delete)
  hardDeleteRole: {
    key: "hardDeleteRole",
    url: (data) => `/api/v1/roles/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllRoles", "getDeletedRoles"],
    },
  },

  /* -------------------------------- PATCH / DELETE -------------------------------- */
  updateRole: {
    key: "updateRole",
    url: (data) => `/api/v1/roles/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getAllRoles", "getRolesByCurrentUser"],
    },
  },

  softDeleteRole: {
    key: "softDeleteRole",
    url: (data) => `/api/v1/roles/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllRoles", "getDeletedRoles"],
    },
  },
};
